var s = Object.defineProperty;
var m = (t, e, a) => e in t ? s(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a;
var o = (t, e, a) => m(t, typeof e != "symbol" ? e + "" : e, a);
import { BaseEnvironment as i } from "./main6.js";
class n extends i {
  constructor() {
    super(...arguments);
    /**
     * Webmotors base domain
     *
     */
    o(this, "domain", "hportal.webmotors.com.br");
    /**
     * Enable logging for HML Environment
     *
     */
    o(this, "logging", !0);
    /**
     * Webmotors api URL
     *
     */
    o(this, "apiURL", `https://${this.domain}/api`);
    /**
     * Webmotors private api URL
     *
     */
    o(this, "apiPrivateURL", "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api");
    /**
     * Webmotors base URL
     *
     */
    o(this, "baseURL", `https://${this.domain}`);
    /**
     * Cookie domain on HML environment
     *
     */
    o(this, "cookieDomain", [this.domain, `.${this.domain}`, ".webmotors.com.br"]);
    /**
     * Auth Cookie Name on staging environment
     *
     */
    o(this, "authCookieName", "webmotors.jwt.token.hk");
    /**
     * Access Token Cookie Name on staging environment
     *
     */
    o(this, "accessTokenCookieName", "webmotors.access.token");
    /**
     * Refresh Token Cookie Name on staging environment
     *
     */
    o(this, "refreshTokenCookieName", "webmotors.refresh.token.hk");
    /**
     * Vehicle photo path on HML environment
     *
     */
    o(this, "photoPath", "https://himage.webmotors.com.br");
    /**
     * Webmotors chat api websocket URL
     *
     */
    o(this, "chatApiUrl", "wss://hchat.webmotors.com.br");
    /**
     * Hot deal image path on HML environment
     *
     */
    o(this, "hotDealImage", "https://image.webmotors.com.br/feiroes/imagens/hml/_portal/");
    /**
     * Data Dog Sample Config
     */
    o(this, "traceSampleRate", 100);
    o(this, "sessionSampleRate", 10);
    o(this, "sessionReplaySampleRate", 10);
    /**
     * Seller shield image path
     */
    o(this, "sellerShieldImage", "https://s3.amazonaws.com/webmotors/blindagem-fotos/hml/");
    /**
     * Login route
     *
     */
    o(this, "loginRoute", `https://${this.domain}/login`);
  }
}
export {
  n as HmlEnvironment
};
